module.exports = __webpack_public_path__ + "img/gmail.5d786e99.png";